import styled, { css } from 'styled-components'

const variants = {
  primary: () => css`
    background-color: var(--theme-primary);
    color: var(--theme-secondary);
  `,
  secondary: () => css`
    background-color: var(--theme-secondary);
    color: var(--text-secondary);
  `,
  outlined: () => css`
    background-color: transparent;
    border: 1px solid var(--theme-primary);
    color: var(--theme-primary);
  `,
  link: () => css`
    background-color: transparent;
    color: var(--text-secondary);
  `,
  textLink: () => css`
    display: inline-flex;
    width: fit-content;
    height: unset;
    background-color: transparent;
    color: var(--text-secondary);
    padding: 0;
  `,
  outlinedLink: () => css`
    background-color: transparent;
    color: var(--theme-primary);
    font-size: var(--font-size-sm);
  `,
  outlinedLinkDefault: () => css`
    background-color: transparent;
    color: var(--theme-primary);
  `,
  tableButton: () => css`
    background-color: transparent;
    color: var(--text-tertiary);
    font-weight: bold;
  `
}

export const Button = styled.button`
  ${({
    height,
    variant,
    width,
    margin,
    padding,
    color,
    textWeight,
    fontSize
  }) => css`
    display: flex;
    align-items: center;
    justify-content: center;

    height: ${height ? height : 'auto'};
    width: ${width ? width : '100%'};
    font-size: ${`${fontSize}px` || '16px'};
    font-weight: ${textWeight || 'normal'};
    white-space: nowrap;

    border: none;
    border-radius: var(--border-radius-lg);
    cursor: pointer;

    margin: ${margin ? margin : 0};
    padding: ${width === 'auto' ? '0px 10px' : '8px 16px'};
    ${!!variant && variants[variant]}
    ${padding &&
    css`
      padding: ${padding};
    `}

    ${color &&
    css`
      color: ${color} !important;
    `}

    :disabled {
      cursor: not-allowed;
      opacity: 0.7;
    }
  `}
`

export const Input = styled.input``
